<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import MainFilterSelect from '../PaymentsMainFilterSelect';

export default {
  name: 'MainFilters',
  components: {
    MainFilterSelect,
  },
  computed: {
    ...mapState({
      selectedBrands: state => state.clientPayments.filter.data.selectedBrands,
      selectedDomains: state => state.clientPayments.filter.data.selectedDomains,
      brands: state => state.clientPayments.filter.data.brands,
      filterLoading: state => state.clientPayments.filter.data.loading,
      filterError: state => state.clientPayments.filter.data.error,
      loading: state => state.clientPayments.tableData.loading,
    }),
    ...mapGetters({
      domains: 'clientPayments/getDomainsForFilter',
    }),
    disabled() {
      return this.filterLoading || this.filterError || this.loading;
    },
  },
  methods: {
    ...mapActions({
      updateBrand: 'clientPayments/updateSelectedBrands',
      updateDomains: 'clientPayments/updateSelectedDomains',
    }),
  },
};
</script>

<template>
  <v-content class="ma-0 pa-0">
    <h2 class="text-xs-center">{{ $t('payments.filters.domains') }}</h2>
    <v-divider class="date-filter__divider"/>
    <v-container grid-list-md>
      <v-layout row justify-center>
        <v-flex xs8>
          <main-filter-select
            :availableItems="brands"
            :selectedItems="selectedBrands"
            :updateItems="updateBrand"
            :label="$t('payments.filters.brands')"
            :disabled="disabled"
          />
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-flex xs8>
          <main-filter-select
            :availableItems="domains"
            :selectedItems="selectedDomains"
            :updateItems="updateDomains"
            :label="$t('payments.filters.domains')"
            :disabled="disabled"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/components/payments/client-payments/ClientPaymentsMainFilters.vue